import React from "react";
import { usePage } from "@inertiajs/inertia-react";
import List from "../List/List";
import ListItem from "../ListItem";
import { Drawer } from "./Drawer";

export const DiscoverDrawer = ({activeTab, setActiveTab, items}) => {
    let {isLoggedIn, video} = usePage().props;

    return (
        <Drawer
            drawerId='discover'
            activeTab={activeTab}
            setActiveTab={setActiveTab}
        >
            <List
                isLoggedIn={isLoggedIn}
                showRegisterOverlay={false}
                elements={items}
                totalElements={items.length}
                viewportWidth={200}
                listItem={(el) => <ListItem
                    imageUrl={el.thumbnail_url}
                    title={el.title}
                    isHorizontalScroll={false}
                    isActive={video ? video.id === el.id : false}
                    date={el.youtube_published_at}
                    link={'/on-demand/watch/' + el.slug}
                    sermonId={el?.episode_identifier_string}
                    itemIsLocked={el.is_locked ? el.is_locked : !isLoggedIn && el.pivot && !el.pivot.is_latest_video}
                    videoDuration={el.video_duration ?? ''}
                />}
            />
        </Drawer>
    );
};
